import { useState } from 'react';

const images = [
  'https://dummyimage.com/600x400/000/fff',
  'https://dummyimage.com/600x400/fff/#ff0000',
  'https://dummyimage.com/600x400/000/102221',
];

export const ImageSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStartX, setTouchStartX] = useState(null);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    if (touchStartX === null) return;
    const touchEndX = e.changedTouches[0].clientX;
    const diff = touchStartX - touchEndX;

    if (diff > 50) goToNext();
    else if (diff < -50) goToPrevious();

    setTouchStartX(null);
  };

  return (
    <div style={{ margin: '0 16px' }}>
      <div
        style={{
          position: 'relative',
          width: '100%',
          margin: '0 auto',
          maxWidth: '600px',
          aspectRatio: '3 / 2', // Замість height
        }}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <img
          src={images[currentIndex]}
          alt="slider"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: 'var(--radius-lg)',
            boxShadow: 'var(--shadow-md)',
          }}
        />
        <button
          onClick={goToPrevious}
          style={{
            position: 'absolute',
            top: '50%',
            left: '10px',
            transform: 'translateY(-50%)',
            background: 'var(--gradient-primary)',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: '36px',
            height: '36px',
            boxShadow: 'var(--shadow-sm)',
            cursor: 'pointer',
          }}
        >
          ‹
        </button>
        <button
          onClick={goToNext}
          style={{
            position: 'absolute',
            top: '50%',
            right: '10px',
            transform: 'translateY(-50%)',
            background: 'var(--gradient-primary)',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: '36px',
            height: '36px',
            boxShadow: 'var(--shadow-sm)',
            cursor: 'pointer',
          }}
        >
          ›
        </button>
      </div>
    </div>
  );
};
